import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

export default function ImportPreview({ data, onConfirm, onCancel, loading }) {
  const [selected, setSelected] = useState(() =>
    data.transactions.map((_, i) => !data.transactions[i].is_duplicate)
  );
  const [editedTransactions, setEditedTransactions] = useState(data.transactions);

  const toggleAll = (checked) => setSelected(selected.map(() => checked));
  const deselectDuplicates = () =>
    setSelected(editedTransactions.map((tx) => !tx.is_duplicate));

  const selectedCount = selected.filter(Boolean).length;

  const handleDescriptionChange = (index, value) => {
    const updated = [...editedTransactions];
    updated[index] = { ...updated[index], description: value };
    setEditedTransactions(updated);
  };

  const handleConfirm = () => {
    const confirmed = editedTransactions.filter((_, i) => selected[i]);
    onConfirm(confirmed);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold">
            Vista previa de importacion
          </h3>
          <p className="text-sm text-slate-500">
            {data.total} movimientos encontrados
            {data.duplicates > 0 && (
              <span className="text-amber-600 ml-2">
                ({data.duplicates} posibles duplicados)
              </span>
            )}
            {data.date_range && data.date_range.from && (
              <span className="ml-2">
                | {data.date_range.from} a {data.date_range.to}
              </span>
            )}
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="ghost" size="sm" onClick={() => toggleAll(true)}>
            Seleccionar todos
          </Button>
          {data.duplicates > 0 && (
            <Button variant="ghost" size="sm" onClick={deselectDuplicates}>
              Quitar duplicados
            </Button>
          )}
        </div>
      </div>

      <div className="border rounded-lg overflow-auto max-h-[500px]">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 sticky top-0">
            <tr>
              <th className="p-2 text-left w-10">
                <Checkbox
                  checked={selectedCount === editedTransactions.length}
                  onCheckedChange={toggleAll}
                />
              </th>
              <th className="p-2 text-left">Fecha</th>
              <th className="p-2 text-left">F.Valor</th>
              <th className="p-2 text-left">Concepto</th>
              <th className="p-2 text-right">Importe</th>
              <th className="p-2 text-right">Saldo</th>
            </tr>
          </thead>
          <tbody>
            {editedTransactions.map((tx, i) => (
              <tr
                key={i}
                className={`border-t ${tx.is_duplicate ? "bg-amber-50" : ""} ${
                  !selected[i] ? "opacity-50" : ""
                }`}
              >
                <td className="p-2">
                  <Checkbox
                    checked={selected[i]}
                    onCheckedChange={(checked) => {
                      const next = [...selected];
                      next[i] = checked;
                      setSelected(next);
                    }}
                  />
                </td>
                <td className="p-2">{tx.date}</td>
                <td className="p-2 text-slate-500">{tx.value_date}</td>
                <td className="p-2">
                  <Input
                    value={tx.description}
                    onChange={(e) => handleDescriptionChange(i, e.target.value)}
                    className="h-7 text-sm"
                  />
                  {tx.is_duplicate && (
                    <span className="text-xs text-amber-600">Posible duplicado</span>
                  )}
                </td>
                <td className={`p-2 text-right font-mono ${tx.amount < 0 ? "text-red-600" : "text-emerald-600"}`}>
                  {tx.amount.toLocaleString("es-ES", { minimumFractionDigits: 2 })} {tx.currency}
                </td>
                <td className="p-2 text-right font-mono text-slate-600">
                  {tx.balance != null
                    ? tx.balance.toLocaleString("es-ES", { minimumFractionDigits: 2 })
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex justify-end gap-3">
        <Button variant="outline" onClick={onCancel} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={handleConfirm} disabled={loading || selectedCount === 0}>
          {loading
            ? "Importando..."
            : `Confirmar importacion (${selectedCount} movimientos)`}
        </Button>
      </div>
    </div>
  );
}
